export const text = {
  descHero:
    "برند Smart از سال ۲۰۱۱ فعالیت خود را در زمینه‌ی محصولات حمام، سرویس بهداشتی و آشپزخانه آغاز کرده است. از ابتدا، هدف ما ارائه‌ی محصولات لوکس، بادوام و کاربردی بوده تا تجربه‌ای تازه از کیفیت، زیبایی و رفاه را برای خانواده‌های ایرانی فراهم کنیم. امروز، با همکاری گسترده با فروشندگان در سراسر کشور، Smart به برندی معتبر و شناخته‌شده تبدیل شده و با افتخار،  نماینده انحصاری برندهای DEFNE BANYO و EKO در ایران است. مأموریت ما همچنان زیباتر، ساده‌تر و لذت‌بخش‌تر کردن زندگی روزمره شماست.    ",
  popular: "محبوب ترین محصولات اسمارت",
  categoryTitle: "کنترل کامل، در دستان شما",
  categoryDesc:
    "تمامی تجهیزات خانه و حمام هوشمند از طریق موبایل یا تبلت به‌سادگی قابل مدیریت هستند.",
  mirrorSection: {
    tag: "در نمای نزدیک ببینید",
    title: "جزئیات محصول، دقیق و شفاف",
    desc: "با نمایش بخش‌های مختلف مثل بدنه، لامپ، پایه و دکمه‌ها، قبل از خرید دید کامل‌تری از ساختار و طراحی محصول خواهید داشت.",
  },
  ARSection: {
    tag: "در نمای نزدیک ببینید",
    btn: " محصولات AR",
    title: "تجربه محصول در فضای واقعی",
    desc: "با استفاده از قابلیت واقعیت افزوده، محصول را مستقیماً در فضای حمام یا سرویس بهداشتی خود ببینید. این امکان به شما کمک می‌کند ابعاد، تناسب و جای‌گیری محصول را پیش از انتخاب نهایی بهتر ارزیابی کنید.",
  },
  ARProductsSlider: {
    title: "پیش از خرید / به خانه تان بیاورید",
    desc: "این محصولات امکان مشاهده در فضای واقعی را دارند تا قبل از انتخاب، دید دقیق‌تری از ابعاد، طراحی و جای‌گیری آن‌ها داشته باشید.",
  },
  exhibition: {
    title: "حضور اسمارت در نمایشگاه‌ها",
    desc: "اسمارت با حضور در نمایشگاه‌های تخصصی صنعت ساختمان و تجهیزات حمام و سرویس بهداشتی، محصولات خود را به‌صورت حضوری معرفی می‌کند و فرصت آشنایی نزدیک‌تر با کیفیت، طراحی و جزئیات را فراهم می‌سازد.",
    btn: " اخذ نمایندگی",
  },
  support: {
    title: "ارتباط با ما",
    desc: "برای دریافت اطلاعات بیشتر درباره محصولات، فروشگاه‌ها یا شرایط همکاری، می‌توانید از راه‌های ارتباطی زیر با اسمارت در تماس باشید.",
    consultation: "شماره تماس جهت مشاوره",

  },
  blogSection: {
    tag: "اسمارت بخوانید",
    title: "جزئیات محصول، دقیق و شفاف",
    desc: "با نمایش بخش‌های مختلف مثل بدنه، لامپ، پایه و دکمه‌ها، قبل از خرید دید کامل‌تری از ساختار و طراحی محصول خواهید داشت."
  },
  blogPageSec1:{
    tag: "  مقالات مهم اسمارت",
    title: "مطالبی که به انتخاب بهتر کمک می‌کنند",
    desc:"در این بخش، مقالات منتخب اسمارت را می‌خوانید؛ مطالبی کاربردی درباره انتخاب لوازم حمام و سرویس بهداشتی، بررسی محصولات، نکات پروژه‌ای و راهنمایی‌هایی که تصمیم‌گیری را ساده‌تر می‌کنند."
  },
  blogPageSec2:{
    tag: "دیگر عناوین مهم",
    title: "  مقالات دیگر از اسمارت",
    desc:"در این بخش، مقالات دیگر اسمارت را می‌خوانید؛ مطالبی کاربردی درباره انتخاب لوازم حمام و سرویس بهداشتی، بررسی محصولات، نکات پروژه‌ای و راهنمایی‌هایی که تصمیم‌گیری را ساده‌تر می‌کنند."
  },

  admin: {
    common: {
      loading: "در حال بارگذاری...",
      saving: "در حال ذخیره...",
      delete: "حذف",
      cancel: "انصراف",
      edit: "ویرایش",
      create: "ایجاد",
      operations: "عملیات",
      close: "بستن",
      confirm: "تایید",
      select: "انتخاب",
      add: "افزودن",
      remove: "حذف",
      empty: "آیتمی یافت نشد",
      confirmDelete: "آیا مطمئن هستید؟",
      confirmDeleteMessage: "آیا از حذف این مورد اطمینان دارید؟",
      deleteConfirm: "آیا از حذف",
      deleteConfirmEnd: "اطمینان دارید؟",
    },
    products: {
      title: "مدیریت محصولات",
      create: "ایجاد محصول جدید",
      edit: "ویرایش محصول",
      empty: "محصولی یافت نشد",
      fields: {
        id: "شناسه",
        name: "نام",
        price: "قیمت",
        title: "عنوان",
        sku: "SKU",
        brand: "برند",
        category: "دسته‌بندی",
        material: "جنس",
        description: "توضیح کوتاه",
        content: "توضیحات",
        arLink: "لینک AR",
        width: "عرض (سانتی‌متر)",
        height: "ارتفاع (سانتی‌متر)",
        length: "طول (سانتی‌متر)",
        weight: "وزن (کیلوگرم)",
        titleDsc: "عنوان دوم",
        tags: "تگ‌ها",
        attributes: "ویژگی‌ها",
        environment: "محیط",
        images: "تصاویر محصول (حداکثر 10 تصویر)",
        ar: "دارای AR",
        isSmart: "محصول هوشمند",
        uploadImage: "آپلود تصویر",
        productColor: "رنگ محصول",
        selectColor: "انتخاب رنگ",
        imageNumber: "تصویر",
        tagPlaceholder: "تگ را وارد کنید و Enter بزنید",
        attributePlaceholder: "ویژگی را وارد کنید و Enter بزنید",
        environmentPlaceholder: "محیط را وارد کنید و Enter بزنید",
        selectCategory: "انتخاب دسته‌بندی",
        imageSizeWarning: "می‌توانید حداکثر 10 تصویر برای محصول آپلود کنید. حجم هر تصویر باید کمتر از 1 مگابایت باشد.",
      },
      validation: {
        titleRequired: "عنوان الزامی است",
        skuRequired: "SKU الزامی است",
        brandRequired: "برند الزامی است",
        categoryRequired: "دسته‌بندی الزامی است",
        materialRequired: "جنس الزامی است",
        descriptionRequired: "توضیحات الزامی است",
        widthRequired: "عرض محصول را وارد کنید",
        weightRequired: "وزن محصول را وارد کنید",
        heightRequired: "ارتفاع محصول را وارد کنید",
        lengthRequired: "طول محصول را وارد کنید",
        contentRequired: "توضیحات محصول را وارد کنید",
        environmentEmpty: "لطفاً حداقل یک محیط برای محصول انتخاب کنید",
        skuEmpty: "لطفاً SKU محصول را وارد کنید",
        brandEmpty: "لطفاً برند محصول را وارد کنید",
        categoryEmpty: "لطفاً دسته‌بندی محصول را وارد کنید",
        materialEmpty: "لطفاً جنس محصول را وارد کنید",
        descriptionEmpty: "لطفاً توضیحات محصول را وارد کنید",
        tagsEmpty: "لطفاً حداقل یک تگ برای محصول اضافه کنید",
        attributesEmpty: "لطفاً حداقل یک ویژگی برای محصول اضافه کنید",
        imagesEmpty: "لطفاً حداقل یک تصویر برای محصول آپلود کنید",
        imageSizeError: "حجم تصویر باید کمتر از 1 مگابایت باشد",
        arLinkRequired: "لینک AR الزامی است",
      },
      meta: "مدیریت Meta",
      faq: "مدیریت FAQ",
    },
    categories: {
      title: "مدیریت دسته‌بندی‌ها",
      create: "ایجاد دسته‌بندی جدید",
      edit: "ویرایش دسته‌بندی",
      empty: "دسته‌بندی‌ای یافت نشد",
      fields: {
        id: "شناسه",
        title: "عنوان فارسی",
        titleEn: "عنوان انگلیسی",
        content: "محتوا",
      },
      validation: {
        titleRequired: "عنوان فارسی الزامی است",
        titleEnRequired: "عنوان انگلیسی الزامی است",
        contentRequired: "محتوا الزامی است",
      },
    },
    brands: {
      title: "مدیریت برندها",
      create: "ایجاد برند جدید",
      edit: "ویرایش برند",
      empty: "برندی یافت نشد",
      fields: {
        id: "شناسه",
        name: "نام برند",
      },
      validation: {
        nameRequired: "نام برند الزامی است",
      },
    },
    materials: {
      title: "مدیریت متریال‌ها",
      create: "ایجاد متریال جدید",
      edit: "ویرایش متریال",
      empty: "متریالی یافت نشد",
      fields: {
        id: "شناسه",
        name: "نام متریال",
      },
      validation: {
        nameRequired: "نام متریال الزامی است",
      },
    },
    blog: {
      title: "مدیریت بلاگ",
      create: "ایجاد پست جدید",
      edit: "ویرایش پست",
      empty: "پستی یافت نشد",
      fields: {
        id: "شناسه",
        title: "عنوان",
        date: "تاریخ",
        content: "محتوا",
        desc: "توضیحات / خلاصه",
        tags: "تگ‌ها",
        image: "تصویر",
        tagPlaceholder: "تگ جدید را وارد کنید...",
      },
      validation: {
        titleRequired: "عنوان الزامی است",
        contentRequired: "محتوا الزامی است",
        descRequired: "توضیحات الزامی است",
        tagsEmpty: "لطفا حداقل یک تگ اضافه کنید",
        imageEmpty: "لطفا یک تصویر انتخاب کنید",
      },
    },
    stores: {
      title: "مدیریت فروشگاه‌ها",
      create: "ایجاد فروشگاه جدید",
      edit: "ویرایش فروشگاه",
      empty: "فروشگاهی یافت نشد",
      fields: {
        id: "شناسه",
        title: "عنوان",
        phone: "تلفن",
        address: "آدرس",
        latitude: "عرض جغرافیایی",
        longitude: "طول جغرافیایی",
        province: "استان",
        city: "شهر",
        image: "تصویر فروشگاه",
        catalog: "کاتالوگ",
        selectProvince: "انتخاب استان",
        selectCity: "انتخاب شهر",
        latitudePlaceholder: "مثال: 35.7448",
        longitudePlaceholder: "مثال: 51.3755",
        imageSizeWarning: "حجم تصویر باید کمتر از 1 مگابایت باشد",
        catalogSizeWarning: "حجم کاتالوگ باید کمتر از 10 مگابایت باشد",
        catalogExists: "کاتالوگ موجود است",
      },
      validation: {
        titleRequired: "عنوان الزامی است",
        phoneRequired: "شماره تلفن الزامی است",
        addressRequired: "آدرس الزامی است",
        latitudeRequired: "عرض جغرافیایی الزامی است",
        longitudeRequired: "طول جغرافیایی الزامی است",
        provinceRequired: "استان الزامی است",
        cityRequired: "شهر الزامی است",
        titleEmpty: "لطفاً عنوان فروشگاه را وارد کنید",
        phoneEmpty: "لطفاً شماره تلفن را وارد کنید",
        addressEmpty: "لطفاً آدرس را وارد کنید",
        latitudeEmpty: "لطفاً عرض جغرافیایی را وارد کنید",
        longitudeEmpty: "لطفاً طول جغرافیایی را وارد کنید",
        provinceEmpty: "لطفاً استان را انتخاب کنید",
        cityEmpty: "لطفاً شهر را وارد کنید",
        imageEmpty: "لطفاً تصویر فروشگاه را آپلود کنید",
        catalogEmpty: "لطفاً کاتالوگ را آپلود کنید",
        imageSizeError: "حجم تصویر باید کمتر از 1 مگابایت باشد",
        catalogSizeError: "حجم کاتالوگ باید کمتر از 10 مگابایت باشد",
      },
    },
    users: {
      title: "مدیریت کاربران",
      create: "ایجاد کاربر جدید",
      edit: "ویرایش کاربر",
      empty: "کاربری یافت نشد",
      fields: {
        id: "شناسه",
        fullName: "نام کامل",
        mobile: "شماره موبایل",
        password: "رمز عبور",
      },
      validation: {
        mobileRequired: "شماره موبایل الزامی است",
        mobileInvalid: "شماره موبایل معتبر نیست",
        passwordRequired: "رمز عبور الزامی است",
        passwordMinLength: "رمز عبور باید حداقل 6 کاراکتر باشد",
      },
    },
    selectedProducts: {
      title: "محصولات انتخابی",
      add: "افزودن محصول به لیست",
      empty: "محصولی انتخاب نشده است",
      saveOrder: "ذخیره ترتیب",
      selectProduct: "انتخاب محصول",
      maxReached: "حداکثر ۱۰ محصول انتخاب شده است",
      countLabel: "از ۱۰ محصول انتخاب شده",
    },
    selectedStores: {
      title: "فروشگاه‌های انتخابی",
      add: "افزودن فروشگاه به لیست",
      empty: "فروشگاهی انتخاب نشده است",
      saveOrder: "ذخیره ترتیب",
      selectStore: "انتخاب فروشگاه",
      maxReached: "حداکثر ۱۰ فروشگاه انتخاب شده است",
      countLabel: "از ۱۰ فروشگاه انتخاب شده",
    },
    table: {
      id: "شناسه",
      name: "نام",
      title: "عنوان",
      price: "قیمت",
      date: "تاریخ",
      phone: "تلفن",
      province: "استان",
      city: "شهر",
      fullName: "نام کامل",
      mobile: "شماره موبایل",
      titleFa: "عنوان فارسی",
      titleEn: "عنوان انگلیسی",
    },
    colors: {
      gold: "طلایی",
      black: "مشکی",
      silver: "نقره‌ای",
      steel: "استیل",
      colorful: "رنگی",
    },
  },
};
